import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _attachment = {
    image: '_image',
    video: '_videoV2',
    audio: '_audio',
    document: '_document',
};
var _audio = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _bulkDeleteCommentRequest = {};
var _bulkDeleteCommentResponse = {};
var _bulkHideCommentRequest = {};
var _bulkHideCommentResponse = {};
var _bulkModerateDraftContentRequest = {};
var _bulkModerateDraftContentResponse = {};
var _bulkMoveCommentByFilterRequest = {};
var _bulkMoveCommentByFilterResponse = {};
var _bulkPublishCommentRequest = {};
var _bulkPublishCommentResponse = {};
var _comment = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    commentDate: 'google.protobuf.Timestamp',
    content: '_commentContent',
    draftContent: '_commentContent',
};
var _commentContent = {
    commentDate: 'google.protobuf.Timestamp',
    richContent: '_richContent',
    attachments: '_attachment',
};
var _countCommentsRequest = {};
var _countCommentsResponse = {};
var _createCommentRequest = { comment: '_comment' };
var _createCommentResponse = { comment: '_comment' };
var _deleteCommentRequest = {};
var _deleteCommentResponse = {};
var _design = { poll: '_pollDesign' };
var _document = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getCommentRequest = {};
var _getCommentResponse = { comment: '_comment' };
var _getCommentThreadRequest = {};
var _getCommentThreadResponse = {
    comments: '_comment',
    commentReplies: 'Map#_repliesListResponse',
};
var _hideCommentRequest = {};
var _hideCommentResponse = { comment: '_comment' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageData = { image: '_media' };
var _item = { image: '_itemImage', video: '_video' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _listCommentsByResourceRequest = {};
var _listCommentsByResourceResponse = {
    comments: '_comment',
    commentReplies: 'Map#_repliesListResponse',
};
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _markCommentRequest = {};
var _markCommentResponse = { comment: '_comment' };
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _moderateDraftContentRequest = {};
var _moderateDraftContentResponse = { comment: '_comment' };
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _publishCommentRequest = {};
var _publishCommentResponse = { comment: '_comment' };
var _queryCommentsRequest = {};
var _queryCommentsResponse = { comments: '_comment' };
var _repliesListResponse = { replies: '_comment' };
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _unmarkCommentRequest = {};
var _unmarkCommentResponse = { comment: '_comment' };
var _updateCommentRequest = { comment: '_comment' };
var _updateCommentResponse = { comment: '_comment' };
var _video = { media: '_media', thumbnail: '_media' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    posters: '_image',
};
function resolveWixCommentsNgV1CommentsNgUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/comments/v1/comments',
                destPath: '/v1/comments',
            },
        ],
        _: [
            {
                srcPath: '/_api/comments-ng/v1',
                destPath: '/v1',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/comments-ng/v1',
                destPath: '/v1',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/comments-ng/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a new comment.
 *
 * The `appId`, `contextId`, and `resourceId` are all required and associate the created comment with the specific
 * resource it responds to. See [Integrations](https://dev.wix.com/api/rest/comments/comments/introduction#comments_comments_introduction_integrations) for a list of integrated scopes for these fields.
 *
 * If the created comment is a direct response to another comment, the `commentId` of the parent comment should be passed
 * as `parentComment.id` in this comment's request. See [Terminology](https://dev.wix.com/api/rest/comments/comments/introduction#comments_comments_introduction_terminology) for additional information on parent comments and replies.
 */
export function createComment(payload) {
    var _a = serializer(_createCommentRequest, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __createComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'POST',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.CreateComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createComment.fromReq = fromReq;
    __createComment.__isAmbassador = true;
    return __createComment;
}
/** Retrieves a comment. */
export function getComment(payload) {
    var _a = serializer(_getCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'GET',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.GetComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{commentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getComment.fromReq = fromReq;
    __getComment.__isAmbassador = true;
    return __getComment;
}
/**
 * Updates a comment.
 *
 * Each time the comment is updated, `revision` increments by 1. The current `revision` must be
 * passed when updating the comment. This ensures you're working with the latest comment and
 * prevents unintended overwrites.
 */
export function updateComment(payload) {
    var _a = serializer(_updateCommentRequest, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __updateComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'PATCH',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.UpdateComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{comment.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateComment.fromReq = fromReq;
    __updateComment.__isAmbassador = true;
    return __updateComment;
}
/**
 * Deletes a comment.
 *
 * This endpoint deletes the `content` of the comment and sets its `status` to `DELETED`.
 */
export function deleteComment(payload) {
    var _a = serializer(_deleteCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCommentResponse, {}).fromJSON;
    function __deleteComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'DELETE',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.DeleteComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{commentId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteComment.fromReq = fromReq;
    __deleteComment.__isAmbassador = true;
    return __deleteComment;
}
/**
 * Moderates the draft content of a comment.
 *
 * - `APPROVE`: Moves `draftContent` to `content` and updates the comment `status` to `PUBLISHED`.
 * - `REJECT`: Clears `draftContent` if comment `status` is `PUBLISHED` or, if comment `status` is `PENDING` it will keep `draftContent` the same and change `status` to `HIDDEN`.
 */
export function moderateDraftContent(payload) {
    var _a = serializer(_moderateDraftContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_moderateDraftContentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __moderateDraftContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'POST',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.ModerateDraftContent',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{commentId}/moderate',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __moderateDraftContent.fromReq = fromReq;
    __moderateDraftContent.__isAmbassador = true;
    return __moderateDraftContent;
}
/**
 * Retrieves a list of comments, given the provided paging, filtering, and sorting.
 *
 * Query Comments runs with these defaults, which you can override:
 * - `id` sorted in `ASC` order
 *
 * For field support for filters and sorting, see [Comments: Supported Filters and Sorting]().
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryComments(payload) {
    var _a = serializer(_queryCommentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCommentsResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __queryComments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'POST',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.QueryComments',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/query-cursor',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryComments.fromReq = fromReq;
    __queryComments.__isAmbassador = true;
    return __queryComments;
}
/**
 * Sets `marked` to `TRUE` to mark a comment.
 *
 * You can then filter for marked comments with [Query Comments](#query-comments) to apply customizations.
 * See Highlight marked comments for an example.
 */
export function markComment(payload) {
    var _a = serializer(_markCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __markComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'PUT',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.MarkComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{commentId}/mark',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markComment.fromReq = fromReq;
    __markComment.__isAmbassador = true;
    return __markComment;
}
/** Sets `marked` to `FALSE` to unmark a comment. */
export function unmarkComment(payload) {
    var _a = serializer(_unmarkCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unmarkCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __unmarkComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'PUT',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.UnmarkComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{commentId}/unmark',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unmarkComment.fromReq = fromReq;
    __unmarkComment.__isAmbassador = true;
    return __unmarkComment;
}
/** Hides a comment. */
export function hideComment(payload) {
    var _a = serializer(_hideCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_hideCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __hideComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'PUT',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.HideComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{commentId}/hide',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __hideComment.fromReq = fromReq;
    __hideComment.__isAmbassador = true;
    return __hideComment;
}
/** Publishes a comment. */
export function publishComment(payload) {
    var _a = serializer(_publishCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_publishCommentResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __publishComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'PUT',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.PublishComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{commentId}/publish',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __publishComment.fromReq = fromReq;
    __publishComment.__isAmbassador = true;
    return __publishComment;
}
/**
 * Counts comments, given the provided filtering.
 *
 * For field support for filters and sorting, see [Comments: Supported Filters and Sorting]().
 */
export function countComments(payload) {
    var _a = serializer(_countCommentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countCommentsResponse, {}).fromJSON;
    function __countComments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'POST',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.CountComments',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countComments.fromReq = fromReq;
    __countComments.__isAmbassador = true;
    return __countComments;
}
/**
 * Lists published comments and replies
 *
 * API designed to load comments and replies. It return only published comments and replies.
 * Hidden or Deleted comment or reply are not returned unless they have more than one published reply.
 */
export function listCommentsByResource(payload) {
    var _a = serializer(_listCommentsByResourceRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCommentsByResourceResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _repliesListResponse: _repliesListResponse,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __listCommentsByResource(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'GET',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.ListCommentsByResource',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/list-by-resource',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCommentsByResource.fromReq = fromReq;
    __listCommentsByResource.__isAmbassador = true;
    return __listCommentsByResource;
}
/**
 * Return thread of a comment or reply
 *
 * If comment thread requested, the API will return a single comment along with cursors that can be utilized with the
 * ListCommentsByResource API to load previous and subsequent comment pages.
 *
 * In case reply thread requested, the API will return the root parent comment, the reply itself, and cursors that
 * can be utilized with the ListCommentsByResource API to load previous and subsequent pages of comments or replies.
 */
export function getCommentThread(payload) {
    var _a = serializer(_getCommentThreadRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCommentThreadResponse, {
        _appEmbedData: _appEmbedData,
        _attachment: _attachment,
        _audio: _audio,
        _audioData: _audioData,
        _background: _background,
        _comment: _comment,
        _commentContent: _commentContent,
        _design: _design,
        _document: _document,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _repliesListResponse: _repliesListResponse,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoV2: _videoV2,
    }).fromJSON;
    function __getCommentThread(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'GET',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.GetCommentThread',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/comments/{commentId}/thread',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCommentThread.fromReq = fromReq;
    __getCommentThread.__isAmbassador = true;
    return __getCommentThread;
}
/** Publishes multiple comments */
export function bulkPublishComment(payload) {
    var _a = serializer(_bulkPublishCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkPublishCommentResponse, {}).fromJSON;
    function __bulkPublishComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'POST',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.BulkPublishComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/bulk/comments/publish-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkPublishComment.fromReq = fromReq;
    __bulkPublishComment.__isAmbassador = true;
    return __bulkPublishComment;
}
/** Hides multiple comments */
export function bulkHideComment(payload) {
    var _a = serializer(_bulkHideCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkHideCommentResponse, {}).fromJSON;
    function __bulkHideComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'PUT',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.BulkHideComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/bulk/comments/hide-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkHideComment.fromReq = fromReq;
    __bulkHideComment.__isAmbassador = true;
    return __bulkHideComment;
}
/** Deletes multiple comments */
export function bulkDeleteComment(payload) {
    var _a = serializer(_bulkDeleteCommentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteCommentResponse, {}).fromJSON;
    function __bulkDeleteComment(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'PUT',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.BulkDeleteComment',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/bulk/comments/delete-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteComment.fromReq = fromReq;
    __bulkDeleteComment.__isAmbassador = true;
    return __bulkDeleteComment;
}
/** Moderates the draft content of a multiple comments. */
export function bulkModerateDraftContent(payload) {
    var _a = serializer(_bulkModerateDraftContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkModerateDraftContentResponse, {}).fromJSON;
    function __bulkModerateDraftContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'POST',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.BulkModerateDraftContent',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/bulk/comments/moderate-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkModerateDraftContent.fromReq = fromReq;
    __bulkModerateDraftContent.__isAmbassador = true;
    return __bulkModerateDraftContent;
}
/** Moves multiple comments */
export function bulkMoveCommentByFilter(payload) {
    var _a = serializer(_bulkMoveCommentByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkMoveCommentByFilterResponse, {}).fromJSON;
    function __bulkMoveCommentByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.comments.v2.comment',
            method: 'PUT',
            methodFqn: 'wix.comments.ng.v1.CommentsNg.BulkMoveCommentByFilter',
            url: resolveWixCommentsNgV1CommentsNgUrl({
                protoPath: '/v1/bulk/comments/move-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkMoveCommentByFilter.fromReq = fromReq;
    __bulkMoveCommentByFilter.__isAmbassador = true;
    return __bulkMoveCommentByFilter;
}
//# sourceMappingURL=http.impl.js.map